<template>
  <div>
    <table class="table table-hover table-sm trace_table">
      <thead>
      <tr>
        <th width="30"></th>
        <th>Операция</th>
        <th>Информация</th>
        <th>Пользователь</th>
        <th>Дата</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(record, index) in trace">
        <td>{{ index + 1 }}</td>
        <td>{{ actions[record.action_id] }}</td>
        <td>
          <div class="flex">
            <template v-if="record.action_id === 49">
              <div class="mr-2">
                <v-popover
                  popoverClass="popover_trace_letter_body"
                  placement="right"
                  trigger="hover"
                >
                  <i class="icon-fa icon-fa-info info_fa"/>
                  <template slot="popover">
                    <div v-html="record.data.letter.body"/>
                  </template>
                </v-popover>
              </div>
            </template>
            <template v-if="record.action_id === 67">
              <button
                @click="showTask(record.int_value)"
                class="btn btn-xs btn-info ml-1 mr-2"
              >
                <i class="icon-fa icon-fa-eye"></i>
              </button>
              Задача: <strong>{{ record.int_value }}</strong>
            </template>
            <div v-html="printDataByAction(record.action_id, record)"></div>
          </div>
        </td>
        <td>
          <template v-if="record.user_id">({{ record.user_id }}) {{ record.user ? record.user.name : null }}</template>
        </td>
        <td>{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}</td>
      </tr>
      </tbody>
    </table>
    <!--        {{trace}}-->
  </div>
</template>

<script>

import VTooltip from 'v-tooltip'

export default {
  components: {
    VTooltip
  },
  props: [
    'trace', 'sites', 'cities'
  ],
  data() {
    return {
      actions: {
        0: 'Создание заявки вручную',
        1: 'Поступила с сайта',
        10: 'Смена статуса',
        11: 'Препарат удален',
        12: 'Препарат добавлен',
        13: 'Количество изменено',
        14: 'Имя клиента изменено',
        15: 'Email клиента изменен',
        16: 'Телефон удален',
        17: 'Телефон добавлен',
        18: 'Скидка',
        19: 'Доставка',
        20: 'Комментарий',
        21: 'Адрес',
        22: 'Метро',
        23: 'Дата доставки',
        24: 'Параметр добавлен',
        25: 'Параметр изменен',
        26: 'Отмена у менеджера',
        27: 'SUB статус изменен',
        29: 'Назначен курьер',
        30: 'Отмена у курьера',
        31: 'Дата отчета',
        32: 'Идентификатор оплаты',
        33: 'Расчет зарплаты',
        34: 'Дополнительная информация',
        35: 'Смена типа заявки',
        38: 'Телефонный звонок',
        39: 'Смена станции метро',
        40: 'Сумма заявки изменена',
        42: 'Смена статуса заявки(К)',
        45: 'Детали адреса',
        46: 'Смена статуса заявки',
        47: 'Обновление склада',
        48: 'Переведена на систему доставки',
        49: 'Отправлено письмо',
        50: 'Добавлены реквизиты оплаты',
        51: 'Удалены реквизиты',
        53: 'Отправка SMS',
        54: 'Прикрелено SMS',
        52: 'Предоплата подтверждена',
        60: 'Смена дивизиона',
        62: 'Комментарий к препарату',
        63: 'Удален комментарий к препарату',
        64: 'Заявка обрабатывается',
        65: 'Запрос курьера',
        66: 'Принят запрос курьера',
        67: 'Задача на заявку',
      }
    }
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
    $AllProjects() {
      const projects = this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
      return projects
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  methods: {
    showTask(taskId) {
      console.log(taskId);
      this.mixinOpenDrawer({taskId, type: 'taskView'})
    },
    printDataByAction(action, record) {
      let data = record.data
      let text = ''

      // if (!data) return;
      if (!data && !record.text_value) return

      switch (action) {
        case 60:
          text = `<p>${this.$AllDivisions[record.int_value]?.title}</p>`
          break;
        case 65:
          text = `<p><strong>Звонок клиенту</strong></p><p>${data.type_title}</p>`;
          break;
        case 62:
        case 63:
          text = `<p>${data.drug_title}</p><p>${data.text}</p>`;
          break;
        case 52:
          text = `<p>${data?.comment}</p>`;
          break;
        case 54:
          text = `<p>${data.sms_body}</p>`;
          break;
        case 53:
          text = `<p>Телефон: ${data.phone_number}</p><p>${data.sms_body}</p>`;
          break;
        case 50:
          text = `<p>Карта: <strong>${data.card_number}</strong></p><p>Сумма: <strong>${data.sum}</strong></p>`
          break;
        case 49:
          switch (+data.letter.type) {
            case 2:
              text = 'Реквизиты для оплаты'
              break;
            default:
              text = null;
              break;
          }
          break;
        case 47:
          text += '<p class="text-muted">' + JSON.stringify(data) + '</p>'
          break
        case 46:
          if (data.old_text) {
            text += '<p class="text-muted">' + data.old_text + '</p>'
          }
          if (data.new_text) {
            text += '<p><strong>' + data.new_text + '</strong></p>'
          }
          if (data.extra_text) {
            text += '<p>' + data.extra_text + '</p>'
          }
          break
        case 42:
          if (data.old) {
            text += '<p class="text-muted">' + data.old + '</p>'
          }
          if (data.new) {
            text += '<p><strong>' + data.new + '</strong></p>'
          }
          break
        case 39:
          if (!data.manual) {
            text += '<p>Автоматически</p>'
          }
          if (data.text) {
            text += '<p>' + data.text + '</p>'
          }
          if (data.old) {
            text += '<p class="text-muted">' + data.old + '</p>'
          }
          if (data.new) {
            text += '<p>' + data.new + '</p>'
          }
          break

        case 18:
          text += '<p>Установлена скидка: <strong>' + (data.value ?? data.int_value) + '</strong> ' + (!data.discount_type ? 'руб.' : '%') + '</p>'
          if (data.old_value) text += '<p class="text-muted">' + data.old_value + '</p>'
          break

        case 19:
          text += '<p>Установлена доставка: <strong>' + (data.value ?? data.int_value) + '</strong></p>'
          if (data.old_value) text += '<p class="text-muted">' + data.old_value + '</p>'
          break

        case 26:
        case 30:
          text += '<p>' + record.text_value + '</p>'
          break

        case 29:
          if (data.old_user_name) {
            text += '<p class="text-muted">' + data.old_user_name + '</p>'
          } else if (data.old) {
            text += '<p class="text-muted">' + data.old + '</p>'
          }
          if (data.user_name) {
            text += '<p><strong>' + data.user_name + '</strong></p>'
          } else {
            text += '<p><strong>' + data.new + '</strong></p>'
          }
          break

        case 10:
        case 31:
          if (data.old) text += '<p class="text-muted">' + data.old + '</p>'
          text += '<p><strong>' + data.new + '</strong></p>'
          if (data.user_name) {
            text += '<p>' + data.user_name + '</p>'
          }
          break

        case 27:
        case 32:
        case 33:
        case 34:
        case 35:
        case 40:
        case 45:
          if (data.old_value) text += '<p class="text-muted">' + data.old_value + '</p>'
          text += '<p><strong>' + data.value + '</strong></p>'
          break

        case 24:
        case 25:
          if (data.old_value) text += '<p class="text-muted">' + data.old_value + '</p>'
          text += '<p>' + data.title + ': <strong>' + data.value + '</strong></p>'
          break

        case 20:
        case 21:
        case 22:
        case 23:

          if (data.old_value) text += '<p class="text-muted">' + data.old_value + '</p>'
          text += '<p><strong>' + data.value + '</strong> ' + (data.discount_type ? (data.discount_type == 0 ? 'руб' : '%') : '') + '</p>'

          break

        case 16:
        case 17:
          text += '<p><strong>' + data.value + '</strong></p>'
          break

        case 14:
        case 15:
          text += '<strong>Клиент обновлен</strong>'
          text += '<p class="text-muted">' + data.old_value + '</p>'
          text += '<p><strong>' + data.value + '</strong></p>'
          break

        case 11:
        case 12:
        case 13:
          text += '<strong>' + data?.name + '</strong>'
          text += '<p>Количество: <strong>' + data.qty + '</strong></p>'
          text += '<p>Стоимость: <strong>' + data.price + '</strong></p>'
          break

        case 0:
        case 1:

          text += '<strong>Заявка</strong>'
          if (data.order.type && data.order.type == 2) {
            text += '<p><span class="color_dark_red">Возврат</span>: <strong>' + data.order.related_order_id + '</strong></p>'
          }
          text += '<p>Проект: <strong>' + this.$AllProjects[data.order.site_id].title + '</strong></p>'
          text += '<p>Город: <strong>' + this.$AllCities[data.order.city_id]?.name + '</strong></p>'
          text += '<p>Адрес: <strong>' + data.order.address + '</strong></p>'
          if (data.order.metro) text += '<p>Метро: <strong>' + data.order.metro + '</strong></p>'
          if (data.order.delivery_date) {
            text += '<p>Доставка: <strong>' + data.order.delivery_price + '</strong></p>'
            text += '<p>Дата доставки: <strong>' + data.order.delivery_date + '</strong></p>'
            if (data.order.discount) text += '<p>Скидка: <strong>' + data.order.discount + '</strong> ' + (data.order.discount_type == 0 ? 'руб' : '%') + '</p>'
            if (data.order.comment) text += '<p>Комментарий: <strong>' + data.order.comment + '</strong></p>'
          }
          text += '<strong>Клиент</strong>'
          if (data.client)
            text += '<p>Имя: <strong>' + data.client?.name + '</strong></p>'
          else
            text += '<p>Имя: <strong>' + data.order.client_name + '</strong></p>'
          if (data.order.email) text += '<p>Email: <strong>' + data.client.email + '</strong></p>'
          if (data.order.client_email) text += '<p>Email: <strong>' + data.order.client_email + '</strong></p>'

          if (data.phones) {
            data.phones.forEach((p) => {
              text += '<p>Телефон: <strong>' + p + '</strong></p>'
            })
          } else {
            text += '<p>Телефон: <strong>' + data.order.phone + '</strong></p>'
          }
          text += '<strong>Препараты</strong>'
          data.drugs.forEach((d) => {
            text += '<p><strong>' + d.title + '</strong>: ' + d.qty + ' * ' + d.price + '</p>'
          })

          if (data.order.discount) {
            // text += '<p>Скидка: <strong>' + data.order.discount + ' ' + (data.order.discount_type == 0 ? 'руб' : '%' ) + '</strong></p>'
            text += '<p>Скидка: <strong>' + data.order.discount + '</strong></p>'
          }
          text += '<p>Сумма заявки: <strong>' + data.order.price + '</strong></p>'
          break
      }

      return text
    }
  }
}

</script>

<style>
.popover_trace_letter_body {
  padding: 10px;
  width: 50% !important;
  max-width: 50% !important;
}
</style>
<style scoped>
.info_fa {
  padding: 1px 5px;
  background-color: #5BBFDE;
  cursor: pointer;
  border-radius: 50%;
}

.trace_table p {
  margin-bottom: 0;
}

.trace_table td,
.trace_table th {
  padding: 3px;
}

</style>
